import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { normalizeLocale } from '@wikigold/i18n';
import GoldApp, { RulesDialog, type GoldConfig } from './gold-v2/GoldApp';
import { IntroPage } from './intro/IntroPage';
import { captureFirstSource } from './intro/source';
import { gameEntryHref, isIntroductionPath } from './i18n/entry-routing';
import { setAppLocale } from './i18n/I18nProvider';
import { api } from './lib';

function Introduction() {
  const { t, i18n } = useTranslation();
  const locale = normalizeLocale(i18n.resolvedLanguage ?? i18n.language);
  const [config, setConfig] = useState<GoldConfig | null>(null);
  const [rulesOpen, setRulesOpen] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    // Public configuration only: introduction views never restore/create a player.
    void api<GoldConfig>('/api/gold-v2/config').then(value => {
      if (active) setConfig(value);
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, []);
  return <>
    <IntroPage locale={locale} onLocaleChange={setAppLocale}
      onEnter={() => location.assign(gameEntryHref(locale, location.search, location.hash))}
      onRules={() => setRulesOpen(true)} />
    {rulesOpen && (config ? <RulesDialog config={config} onClose={() => setRulesOpen(false)} />
      : <div className="gold-backdrop" role="dialog" aria-modal="true"><section className="gold-dialog">
        <p>{t(error ? 'error.load' : 'common.loading')}</p>
        <button className="gold-primary" onClick={() => setRulesOpen(false)}>{t('rules.close')}</button>
      </section></div>)}
  </>;
}

export default function EntryApp() {
  const [pathname, setPathname] = useState(() => location.pathname);
  useEffect(() => {
    captureFirstSource(location, document.referrer);
    const sync = () => setPathname(location.pathname);
    window.addEventListener('popstate', sync);
    return () => window.removeEventListener('popstate', sync);
  }, []);
  return isIntroductionPath(pathname) ? <Introduction /> : <GoldApp />;
}
